import { useContext } from 'react';
import UserContext from '../../context/user/UserContext';
import { useLocalStorage } from '../providers/useLocalStorage';

export const buildFilterPreferenceKey = (screen: string, tenantDomain: string, username: string): string =>
  `atestado-web:filter-preference:${screen}:${tenantDomain || 'sem-tenant'}:${username || 'sem-usuario'}`;

export const useFilterPreference = <T>(screen: string) => {
  const { state } = useContext(UserContext);
  const storage = useLocalStorage();

  const key = buildFilterPreferenceKey(screen, state.tenantDomain, state.username);

  const read = (): Partial<T> | null => {
    try {
      const item = storage.getItem(key);
      if (!item || typeof item !== 'object' || Array.isArray(item)) return null;
      return item as Partial<T>;
    } catch (error) {
      return null;
    }
  };

  const write = (preference: T): void => {
    storage.setItem(key, preference);
  };

  const remove = (): void => {
    storage.removeItem(key);
  };

  return { key, read, write, remove };
};
